import * as React from 'react';
var RangeContext = React.createContext({});
export default RangeContext;